import React from 'react';
import { Modal } from 'react-bootstrap';
import ProSite from './CreateSiteForm';
import { showCreateSiteModal, setDraggedFile, toggleModal } from '../../Manage/actions';

import { connect } from 'react-redux';

const CreateSiteModal = ({ show, dispatch, disableProFeatures, ...rest }) => {
  const siteModalProps = { ...rest, disableProFeatures };
  const handleClose = () => {
    dispatch(setDraggedFile(null));
    dispatch(showCreateSiteModal(false));

    dispatch(toggleModal(false));
  };
  return (
    <Modal show={show} aria-labelledby="contained-modal-title-vcenter" centered onHide={handleClose} {...rest}>
      <ProSite {...siteModalProps} />

    </Modal>
  );
};

const mapStateToProps = ({ manage: { createSiteModal } }) => ({
  action: createSiteModal.action,
  show: createSiteModal.visible,
  data: createSiteModal.data
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(CreateSiteModal);
